import { render } from "./StreamPlayerDynamic.vue?vue&type=template&id=684cfe4f"
import script from "./StreamPlayerDynamic.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamPlayerDynamic.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/DynamicPlayer/StreamPlayerDynamic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "684cfe4f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('684cfe4f', __exports__)) {
    api.reload('684cfe4f', __exports__)
  }
  
  module.hot.accept("./StreamPlayerDynamic.vue?vue&type=template&id=684cfe4f", () => {
    api.rerender('684cfe4f', render)
  })

}


export default __exports__